window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

import $ from 'jquery';

window.$ = window.jQuery = $;

import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import 'bootstrap';

window.bootbox = require('bootbox/bootbox.all');
// import '../../public/js/toastr.min';
import lightbox from 'lightbox2';


axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] =
    document.querySelector('meta[name="csrf-token"]').getAttribute('content');


import Pusher from 'pusher-js';
import Echo from 'laravel-echo';

window.Pusher = Pusher;
window.addEventListener('load', function () {
    if (window.myIdUser !== undefined && window.myIdUser !== null) {
        console.log('user loaded', window.myIdUser);
        const echoOptions = {
            broadcaster: 'pusher',
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
            key: process.env.MIX_PUSHER_APP_KEY,
            wsHost: window.location.host.indexOf('.localhost') !== -1 ? process.env.MIX_PUSHER_WEBSOCKETS_HOST_LOCAL : process.env.MIX_PUSHER_WEBSOCKETS_HOST,
            wsPort: window.location.host.indexOf('.localhost') !== -1 ? process.env.MIX_PUSHER_WEBSOCKETS_PORT_LOCAL :process.env.MIX_PUSHER_WEBSOCKETS_PORT,
            wssPort: window.location.host.indexOf('.localhost') !== -1 ? process.env.MIX_PUSHER_WEBSOCKETS_PORT_LOCAL :process.env.MIX_PUSHER_WEBSOCKETS_PORT,
            encrypted: true,
            disableStats: true,
            forceTLS: window.location.host.indexOf('.localhost') === -1,
            enabledTransports: ['ws', 'wss'],
            // enabledTransports: ['ws'],
            wsPath: window.location.host.indexOf('.localhost') !== -1 ? '/' : '/websockets',
            auth: {
                headers: {}
            }
        }
        const urlParams = new URLSearchParams(window.location.search);
        const grlcValue = urlParams.get('grlc');
        if (grlcValue !== null) {
            echoOptions.auth.headers['X-grlc'] = grlcValue;
        }
        console.log(echoOptions);

        window.Echo = new Echo(echoOptions);
        setupWebsocketsHandler()
    }
});

var sessionEventListener = null;

function setupWebsocketsHandler() {
    if (window.myIdSession && sessionEventListener == null) {
        console.log('sessionEventListener.myIdSession', window.myIdSession);
        sessionEventListener = window.Echo.private('App.GameSession.' + window.myIdSession)
            .listen('GameSyncSessionEvent', (e) => {
                // console.log('GameSyncSessionEvent', e);
                handleEvent(e);
            })
            .error((err) => {
                console.error('❌ SUBSCRIPTION ERROR', err);
            });
    }
}


